import React, { useEffect, useState, useContext, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { Loader } from 'ncoded-component-library';
import { NODE_COMPONENT } from './data';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { FileAccessSelectorProps, NodeChangedPermission } from './types';
import { getDataRoomNodeType } from 'utils';

import './FileAccessSelector.styles.scss';

const FileAccessSelector: React.FC<FileAccessSelectorProps> = (props) => {
  const {
    className,
    hasLoading,
    refetchFlag,
    checkedFilesIds,
    checkedDownloadIds,
    hasDownload,
    orderStageCopies,
    updateFileAccess,
    getBaseNodes,
    getChildrenForNode,
    checkIfNodeIsDisabled,
  } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [nodes, setNodes] = useState<DataRoomNode[]>([]);

  const { popServerError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const classes = classNames('file-access-selector', className);

  const onCheckboxChange = useCallback(
    async (node: NodeChangedPermission) => {
      try {
        setIsLoading(true);

        await updateFileAccess(node);
      } catch (e) {
        popServerError(e);
      } finally {
        setIsLoading(false);
      }
    },
    [popServerError, updateFileAccess],
  );

  // fetching null level
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const data = await getBaseNodes();

        if (data) {
          setNodes(data);
        }
      } catch (e) {
        popServerError(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [refetchFlag, getBaseNodes, popServerError]);

  return (
    <div className={classes}>
      {!isLoading && !nodes.length ? (
        <div className="empty-state">{t('emptyFolder')}</div>
      ) : (
        <ul className="file-access-selector__nodes">
          {nodes.map((node) => {
            const nodeType = getDataRoomNodeType(node);

            return (
              <li
                key={node._id}
                className={`file-access-selector__${nodeType}`}
              >
                {node &&
                  NODE_COMPONENT[nodeType]({
                    node,
                    isLoading,
                    refetchFlag,
                    checkedFilesIds,
                    checkedDownloadIds,
                    hasDownload,
                    orderStageCopies,
                    getChildrenForNode,
                    checkIfNodeIsDisabled,
                    onChange: onCheckboxChange,
                  })}
              </li>
            );
          })}
        </ul>
      )}

      {isLoading && hasLoading && <Loader />}
    </div>
  );
};

export default FileAccessSelector;
